import {
  BrokerageGetRequestQuery,
  BrokerageOfferingsSearchRequestQuery,
  OfferingBrokerageOfferingsSearchRequestQuery,
  OfferingBrokerageOfferingRequestParams,
} from '@lio/api-types';

export const brokerageKeys = {
  get: ['brokerages'] as const,
  getWithParams: (params: any) => [...brokerageKeys.get, params] as const,
  search: ['brokerages'] as const,
  searchWithParams: (params: BrokerageGetRequestQuery) => [...brokerageKeys.search, params] as const,
  brokerage: ['brokerage'] as const,
  brokerages: ['brokerages'] as const,
  brokerageAppointment: ['brokerageAppointment'] as const,
  customerSearch: ['brokerageCustomer'] as const,
  customerSearchWithParams: (params: {
    customerId?: string;
    brokerageId?: string;
    insuranceProductId?: string;
    effectiveDate?: string;
  }) => [...brokerageKeys.customerSearch, params] as const,
  brokerageOfferingsSearch: ['brokerageOfferings'] as const,
  brokerageOfferingsSearchWithParams: (brokerageId: string | undefined, params: BrokerageOfferingsSearchRequestQuery) =>
    ['brokerageOfferings', brokerageId, { ...params }] as const,
  offeringBrokerageOfferingSearch: ['offeringBrokerageOfferings'] as const,
  offeringBrokerageOfferingSearchWithParams: (
    params: OfferingBrokerageOfferingsSearchRequestQuery & OfferingBrokerageOfferingRequestParams,
  ) => [...brokerageKeys.brokerageOfferingsSearch, params] as const,
};
